module.exports = __webpack_public_path__ + "static/media/1.ec645a07.jpg";